import { connect } from 'react-redux';
import { trackEventFromState } from '@eb/site-analytics';
import OnboardingPage from './OnboardingPage';
import { goToOverviewPage } from '../../actions/routing';
import { redirectToContactSales } from '../../actions/redirect';

import {
    copySetPackageTwo,
    goToPackageSelection,
    onboardingRedirectToContactSales,
    redirectToReferer,
    setPackageOne,
    setPackageTwo,
} from '../../actions/onboarding';

const _mapStateToProps = ({ assortments, env, user, eid, gaSettings }) => ({
    assortmentsPricing: assortments.assortmentsPricing,
    feeBreakdown: assortments.feeBreakdown,
    assortmentsTax: assortments.assortmentsTax,
    hasAssortmentsTax: assortments.hasAssortmentsTax,
    crumb: env.crumb,
    locale: env.locale,
    referer: env.referer,
    canAccessLegacyConvert: user.canAccessLegacyConvert,
    canChangePlan: user.canChangePlan,
    isAuthenticated: user.isAuthenticated,
    isCopy: user.isCopy,
    isCreate: user.isCreate,
    isCoyoteCopy: user.isCoyote,
    isLegacy: user.isLegacy,
    trackEvent: (action) =>
        trackEventFromState({ gaSettings, eventId: eid }, action),
    userId: user.userId,
    userType: user.userType,
});

const _mapDispatchToProps = {
    goToOverviewPage,
    setPackageOne,
    setPackageTwo,
    goToPackageSelection,
    redirectToContactSales,
    redirectToReferer,
    copySetPackageTwo,
    onboardingRedirectToContactSales,
};

export const connectPage = (ComponentClass) =>
    connect(_mapStateToProps, _mapDispatchToProps)(ComponentClass);

export const ConnectedOnboardingPage = connectPage(OnboardingPage);
